module.exports = __webpack_public_path__ + "static/media/guillaume-launay-head-of-logistics-lunalogistik.700ace17.jpg";